//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import connect from 'react-redux/es/connect/connect';
import ListagemPage from '../../components/templates/ListagemPage';
import { tableHelper } from '../../helpers/tableHelper';
import withAbility from '../../hoc/withAbility';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import ImportarPedidoCrudListFilter from './ImportarPedidoCrudListFilter';
import { importarPedidoService } from '../../services/importarPedido.service';
import { objectsConstants } from '../../constants/objects.constants';

const endPoint = '/importarPedido/novo/';
const endPointView = '/importarPedido/';
class ImportarPedidoCrudList extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);

    const isSudo = props.user && props.user.perfis.includes('SUDO');

    this.columns = [
      {
        path: 'id',
        title: 'Identificador',
        isKey: true,
        dataSort: false,
        className: 'txtBold',
        hidden: true,
      },
      {
        path: 'status',
        title: 'STATUS',
        dataSort: false,
        isStatusPedido: true,
        width: '150px',
      },
      {
        path: 'numeroPedido',
        title: 'Número do pedido',
        dataSort: false,
        className: 'txtBold',
      },
      {
        path: 'createdAt',
        title: 'Data Criação',
        isDateTime: true,
        dataSort: false,
        width: '200px',
        className: 'txtBold',
      },
      {
        path: 'pontoAtendimentoNome',
        title: 'Ponto de Atendimento',
        isKey: false,
        dataSort: false,
        className: 'txtBold',
      },
      {
        path: 'tipoPedido',
        title: 'Tipo do pedido',
        isKey: false,
        isTipoPedido: true,
        dataSort: false,
      },
      {
        path: 'grupoPedido',
        title: 'Grupo',
        isKey: false,
        dataSort: false,
        dataFormat: this.renderGrupoPedido,
      },
      {
        path: 'subGrupoPedido',
        title: 'Subgrupo',
        isKey: false,
        dataSort: false,
        dataFormat: this.renderSubGrupoPedido,
      },
      { path: 'criadoPorNome', title: 'Criado por', dataSort: false },
      { path: 'aprovadoPorNome', title: 'Aprovado por', dataSort: false },
      {
        path: 'nomePaciente',
        title: 'Paciente',
        dataSort: false,
        className: 'txtBold',
      },
      {
        path: 'cpfPaciente',
        title: 'CPF do paciente',
        dataSort: false,
        className: 'txtBold',
      },
      {
        path: 'urgente',
        title: 'É urgente',
        isKey: false,
        dataSort: false,
        yesNo: true,
        className: 'txtBold',
      },

      ...(isSudo
        ? [
            {
              path: 'clienteNomeFantasia',
              title: 'Cliente',
              isKey: false,
              dataSort: false,
            },
          ]
        : []),
    ];

    const fields = this.columns.map((col) => col.path);
    const labels = this.columns.map((col) => col.title);

    this.state = {
      labels,
      fields,
    };
  }

  getLabelFromOptions = (options, value) => {
    const item = (options || []).find((opt) => opt.value === value);
    return item ? item.label : value || '';
  };

  renderGrupoPedido = (cell) => {
    return this.getLabelFromOptions(objectsConstants.GRUPO_PEDIDO, cell);
  };

  renderSubGrupoPedido = (cell, row) => {
    const grupoPedido = row && row.grupoPedido;
    const tipoPedido = row && row.tipoPedido;

    const options =
      grupoPedido === 'MAPA' || tipoPedido === 'EM_MAPA'
        ? objectsConstants.SUB_GRUPO_PEDIDO_MAPA
        : objectsConstants.SUB_GRUPO_PEDIDO_AVULSO;

    return this.getLabelFromOptions(options, cell);
  };

  handleRowClick = (row: e) => {
    if (this.props.ability.can('update', 'ImportarPedido')) {
      this.props.history.push(endPointView + row.id);
    }
  };

  handleNewButton = (row: e) => {
    this.props.history.push(endPoint);
  };
  render() {
    const fields = this.state.fields;

    const tableColumn = _.map(this.columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={
          column.dataFormat ||
          ((cell, row, _extra, i) =>
            tableHelper.renderCustom(cell, row, column, i))
        }
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    let filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user.extension,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Pedidos Importados"
          subTitle=" "
          canBack={false}
        />
        <ListagemPage
          newButtonActionClick={() => {
            this.props.history.push('/importarPedido/novo');
          }}
          delete={() => {}}
          service={importarPedidoService}
          showNewButton={this.props.ability.can('create', 'ImportarPedido')}
          labelNewButton="Nova importação de pedidos"
          defaultOrder={'nome'}
          defaultDirection={'asc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={ImportarPedidoCrudListFilter}
          fields={fields}
          array={'importarPedidos'}
          pageFilter="pedido-importado"
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(withAbility(ImportarPedidoCrudList));
